import {Component, ViewChild, ViewContainerRef} from "@angular/core";
import {MdDialog, MdDialogRef, MdDialogConfig, MaterialModule} from "@angular/material";
import "rxjs/Rx";

import {GuideService} from "../../services/guide.service";
import {SidenavService} from "../../services/sidenav.service";
import {Spot, Guide, Category} from "../../core/model";

@Component({
    selector: "app",
    template: require<any>("./app.component.html"),
    styles: [
        require<any>("./app.component.less"),
        require<any>("./app.component.scss")
    ],
    providers: []
})
export class AppComponent {

    @ViewChild('sidenav') sidenav: any;

    title = "";
    logo = "";
    constructor(private guideService: GuideService, private sidenavService: SidenavService) {
        this.guideService.getActiveGuide().then(guide => {
            this.title = guide.title;
            this.logo = "assets/guides/" + guide._id + "/images/logo.png";
        });
    }

    ngOnInit() {
        this.sidenavService.setSidenav(this.sidenav);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/app/app.component.ts